import React, { useEffect, useState } from 'react';
import AppContainer from "../core/AppContainer";
import { ViewState } from "../core/ViewStore";
import initEventDispatcher from "../core/bootstrap/initEventDispatcher";
import Routing from "../core/routing/Routing";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { CssBaseline } from "@mui/material";
import { SnackbarProvider, useSnackbar } from "notistack";
import initYup from "../core/bootstrap/initYup";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

type AppProps = {
    initialAppState?: Partial<ViewState>,
    appContainer: AppContainer
}

const App: React.FC<AppProps> = (props) => {
    return (
        <LocalizationProvider dateAdapter={ AdapterLuxon }>
            <ThemeProvider theme={ theme }>
                <CssBaseline/>
                <SnackbarProvider maxSnack={ 5 }>
                    <AppInitializer { ...props } />
                </SnackbarProvider>
            </ThemeProvider>
        </LocalizationProvider>
    )
}

const AppInitializer: React.FC<AppProps> = (props) => {
    const [appState, setAppState] = useState<ViewState>(props.initialAppState || {});

    const { enqueueSnackbar } = useSnackbar();

    const store = props.appContainer.getViewStore();

    useEffect(() => {
        initEventDispatcher(props.appContainer.getEventDispatcher(), props.appContainer);
        initYup();
        props.appContainer.getNotificationDispatcher().setEnqueue(enqueueSnackbar);
        store.setUpdateStateCallback(state => setAppState(state));
        store.updateState(appState);
    }, []);

    return (
        <Routing
            viewPropsFactory={ props.appContainer.getViewPropsFactory() }
            viewStore={ store }
        />
    );
}

export default App;
